const ShareOption = {
  Copy: 'copy',
  Facebook: 'facebook',
  LinkedIn: 'linkedin',
  Twitter: 'twitter'
};

export default ShareOption;
